import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "app/layout/header";
import { Footer } from "app/layout/footer";
import { GetHeaderSearchQuery } from "rest/main";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchResultsPage = () => {
  const query = useQuery();
  const searchText = query.get("query") || "";
  const navigate = useNavigate();
  const { data: searchResults, isLoading } = GetHeaderSearchQuery(searchText);

  return (
    <>
      <Header />
      <div className="container-fluid" style={{ minHeight: "60vh", marginTop: 120 }}>
        <h2>Search Results for: <span style={{ color: '#34caff' }}>{searchText}</span></h2>
        {isLoading && <p>Loading...</p>}
        {!isLoading && (!searchResults?.data || searchResults.data.length === 0) && (
          <p>No results found.</p>
        )}
        {!isLoading && searchResults?.data?.length > 0 && (
          <table className="table table-striped mt-4">
            <thead>
              <tr>
                <th>Title</th>
                <th>Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.data.map((item, idx) => (
                <tr key={idx} style={{ cursor: "pointer" }} onClick={() => window.location.assign(item.detail_url)}>
                  <td>{item.title}</td>
                  <td>{item.type || "-"}</td>
                  <td>
                    <button className="contact_btn" onClick={e => { e.stopPropagation(); window.location.assign(item.detail_url); }}>
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <Footer />
    </>
  );
};

export default SearchResultsPage; 